import React, { useEffect, useState, useRef } from "react";
import 'styles/components/common/Location.scss';
import placeholder from 'assets/images/contact/placeholder.png';
import plus from 'assets/images/contact/plus.png';
import minus from 'assets/images/contact/minus.png';
import { Map, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk";

/**
 * 마커 타이틀에 해당하는 component
 * @returns 마커 타이틀에 해당하는 component 를 반환
 */
const Title = () => {

    return (
        <div className='location'>
            <a href='https://map.kakao.com/link/to/어질인소프트,36.3695301474387, 127.4076818524'
                target='_blank'
                rel='noreferrer'
            >
                <span className='title'>어질인소프트</span>
            </a>
        </div>
    );
}

const Location = () => {

    const [lev, setLev] = useState(2);
    const { kakao } = window;
    const mapRef = useRef();

    /**
     * 창 크기에 따른 지도 레벨을 설정하는 함수
     */
    const handleLev = () => {
        const winSize = window.innerWidth;
        if (winSize >= 768) {
            setLev(2);
        } else {
            setLev(3);
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleLev);
        return () => {
            window.removeEventListener('resize', handleLev);
        }
    }, [])

    /**
     * 카카오맵 지도타입(일반지도/스카이뷰) 커스터마이징 함수
     * @param {string} maptype string 타입의 maptype
     */
    const setMapType = (maptype) => {
        const map = mapRef.current
        const roadmapControl = document.getElementById("btnRoadmap")
        const skyviewControl = document.getElementById("btnSkyview")
        if (maptype === "roadmap") {
            map.setMapTypeId(kakao.maps.MapTypeId.ROADMAP)
            roadmapControl.className = "selected_btn"
            skyviewControl.className = "btn"
        } else {
            map.setMapTypeId(kakao.maps.MapTypeId.HYBRID)
            skyviewControl.className = "selected_btn"
            roadmapControl.className = "btn"
        }
    }

    /**
     * 카카오맵 지도확대(zoomIn) 함수
     */
    const zoomIn = () => {
        const map = mapRef.current
        map.setLevel(map.getLevel() - 1)
    }

    /**
     * 카카오맵 지도축소(zoomOut) 함수
     */
    const zoomOut = () => {
        const map = mapRef.current
        map.setLevel(map.getLevel() + 1)
    }

    return (
        <>
            <div className='map-wrapper'>
                <Map
                    center={{ lat: 36.3695301474387, lng: 127.4076818524 }} // 36.3695301474387, 127.4076818524
                    style={{ width: "100%", height: "100%" }}
                    level={lev}
                    id='map'
                    ref={mapRef}
                >
                    <MapMarker
                        position={{ lat: 36.3695301474387, lng: 127.4076818524 }}
                        image={{
                            src: placeholder,
                            size: {
                                width: 40,
                                height: 40
                            }
                        }}
                    >
                    </MapMarker>
                    <CustomOverlayMap
                        position={{ lat: 36.3695301474387, lng: 127.4076818524 }}
                        yAnchor={1}
                    >
                        <Title />
                    </CustomOverlayMap>
                </Map>
                <div className="custom_typecontrol radius_border">
                    <span
                        id="btnRoadmap"
                        className="selected_btn"
                        onClick={() => setMapType("roadmap")}
                    >
                        지도
                    </span>
                    <span
                        id="btnSkyview"
                        className="btn"
                        onClick={() => {
                            setMapType("skyview")
                        }}
                    >
                        스카이뷰
                    </span>
                </div>
                <div className="custom_zoomcontrol radius_border">
                    <span onClick={zoomIn}>
                        <img
                            src={plus}
                            alt="확대"
                        />
                    </span>
                    <span onClick={zoomOut}>
                        <img
                            src={minus}
                            alt="축소"
                        />
                    </span>
                </div>
            </div>
        </>
    );
};

export default React.memo(Location);
